import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import '../styles/logoCarousel.css'; 

// Import all logos
import wordPressLogo from './assets/logos/wordPressLogo.png';
import reactLogo from './assets/logos/reactLogo2.png';
import postgresSqlLogo from './assets/logos/postgresSqlLogo.png';
import nodeJSLogo from './assets/logos/nodeJS.png';
import mongoDbLogo from './assets/logos/mongoDbLogo.png';
import javaLogo from './assets/logos/javaLogo.png';
import itilLogo from './assets/logos/ItilServiceManagement.png';
import googleAnalyticsLogo from './assets/logos/googleAnalyticsLogo.png';
import gcpLogo from './assets/logos/gcpLogo.png';
import dockerLogo from './assets/logos/dockerLogo.png';
import azureLogo from './assets/logos/azureLogo.png';
import awsLogo from './assets/logos/amazonWebServicesLogo.png';
import firebaseLogo from './assets/logos/firebaseLogo.png';
import javascriptLogo from './assets/logos/frontendLogo.png';
import agileLogo from './assets/logos/agileLogo.png';
import pythonLogo from './assets/logos/pythonLogo.png';

const LogoCarousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: true,
        }
      }
    ]
  };

  const logos = [
    { name: '', image: wordPressLogo },
    { name: '', image: reactLogo },
    { name: '', image: postgresSqlLogo },
    { name: '', image: nodeJSLogo },
    { name: '', image: mongoDbLogo },
    { name: '', image: javaLogo },
    { name: '', image: itilLogo },
    { name: '', image: googleAnalyticsLogo },
    { name: '', image: gcpLogo },
    { name: '', image: dockerLogo },
    { name: '', image: azureLogo },
    { name: '', image: awsLogo },
    { name: '', image: firebaseLogo },
    { name: '', image: javascriptLogo },
    { name: '', image: agileLogo },
    { name: '', image: pythonLogo },
  ];

  return (
    <div className="container mx-auto">
      <div className="lc-logo-carousel">
        <Slider {...settings}>
          {logos.map((logo, index) => (
            <div key={index} className="lc-logo-wrapper">
              <img 
                src={logo.image} 
                alt={`${logo.name} logo`}
                className="lc-logo-image"
              />
              <p className="lc-logo-name">{logo.name}</p>
            </div>
          ))}
        </Slider>
      </div>
    </div> 
  );
};

export default LogoCarousel;